export const GESTATIONAL_CALCULATOR_VIEW = "/gestational-calculator"
export const GESTATIONAL_CALCULATOR_LIST_VIEW =
  GESTATIONAL_CALCULATOR_VIEW + "/all"
export const NEW_GESTATIONAL_CALCULATOR_VIEW =
  GESTATIONAL_CALCULATOR_VIEW + "/new"

// Gestation Calendar Models
export const GESTATION_CALENDAR_TEMPLATE_LIST_VIEW =
  "/gestation-calendar-templates"
export const GESTATION_CALENDAR_TEMPLATE_VIEW = `${GESTATION_CALENDAR_TEMPLATE_LIST_VIEW}/:speciesId`
export const GESTATION_CALENDAR_EVENT_VIEW =
  "/gestation-calendar-event/:eventId"
export const NEW_GESTATION_CALENDAR_EVENT_VIEW =
  GESTATION_CALENDAR_EVENT_VIEW + "/new"
